// extracted by mini-css-extract-plugin
export default {"body":"Body-module__body___xvGTj","bold":"Body-module__bold___RkNBq","muted":"Body-module__muted___Dcp4c","inline":"Body-module__inline___IKqEN"};